export const BusinessStatusCssClasses = {
  approved: "success",
  pending: "info",
  rejected: "danger",
  draft: "warning",
  moreinfo: "secondary",
  "0": "success",
  "1": "info",
  "2": "danger",
  "4": "secondary",
  "5": "warning"
};
export const BusinessStatusTitles = ["active", "inactive","pending","rejected","draft"];
export const BusinessConditionCssClasses = ["success", "danger", ""];
export const BusinessConditionTitles = ["New", "Used"];
export const defaultSorted = [{ dataField: "id", order: "desc" }];
export const sizePerPageList = [
  { text: "30", value: 30 },
  { text: "50", value: 50 },
  { text: "100", value: 100 }
];
export const initialFilter = {
  filter: {
    name: "",
    email: "",
    userid: "",
    status: -1,
  },
  sortOrder: "desc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 50
};
